import Image from 'next/image';
import notFoundImg from '@/app/assets/imgs/not-found.png';
import { cn } from '@/app/utils';

export const ProductEmptyState = ({ className }: { className?: string }) => {
  return (
    <div className={cn('flex min-h-[320px] w-full items-center justify-center py-8 sm:min-h-[240px]', className)}>
      <Image
        src={notFoundImg}
        alt="not found"
        width={425}
        height={310}
        className="h-auto w-full max-w-[425px] sm:max-w-[269px]"
        priority={false}
      />
    </div>
  );
};
